import {Component, Input} from '@angular/core';
import {Entity} from "../../state/entities/entity.model";
import {Store} from "@ngrx/store";
import {DecimalPipe, NgIf} from "@angular/common";
import {TextUtilsService} from "../../services/text-utils.service";
import {cameraActions} from "../../state/camera/camera.actions";
import {Vector3} from "three";
import {User} from "../../auth/primitives/user";
import {usersReducer} from "../../state/users/users.reducer";
import {selectUserById} from "../../state/users/users.selector";
import {IconsService} from "../../services/icons.service";
import {Base64ImageComponent} from "../base64-image/base64-image.component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";

@Component({
  selector: 'search-result-entity',
  standalone: true,
  imports: [
    DecimalPipe,
    NgIf,
    Base64ImageComponent,
    FaIconComponent
  ],
  templateUrl: './search-result-entity.component.html',
  styleUrl: './search-result-entity.component.scss'
})
export class SearchResultEntityComponent {
  pEntity: Entity | any
  owner: User
  subscriptions = []
  @Input() set entity(e: Entity) {
    this.pEntity = this.transformEntity(e)
    this.subscriptions.push(
        this.store.select(selectUserById(e.ownerId)).subscribe((user) => {
          this.owner = user
        })
    )
  }

  constructor(
      private store: Store,
      private textUtilsService: TextUtilsService,
      public iconsService: IconsService
  ) {
  }

  transformEntity(entity: any) {
    return {
      ...entity,
      createdString: this.textUtilsService.fromNowToString(entity.creationDate),
    }
  }

  goToEntity(entity: Entity) {
    this.store.dispatch(cameraActions.targetJumped({
      target: {
        ...entity.coord,
        z: 700
      } as Vector3
    }))
  }
}
